
export namespace EmailGenerationNS {
    export interface Tone {
        name: string;
        tvalue: string;
    }

    export const GenerateEmailTones: Array<Tone> = [
        { name: 'Professional', tvalue: 'pf' },
        { name: 'Casual', tvalue: 'ca' }
    ];

    export interface EmailGenerationScenarioRequest {
        maxLength?: number;
        signature?: string;
        recipients: Array<string>;
        tone: string;
        scenario: string;
    }

    export interface EmailGenerationScenarioModel {
        maxLength?: number;
        signature?: string;
        recipients: Array<string>;
        tone: Tone;
        scenario: string;
        header: string;
        scenarioLable: string;
        generationType: EmailGenerationType;
    }

    export const EmailGenerationScenario: EmailGenerationScenarioModel = {
        maxLength: 500,
        signature: '',
        recipients: [],
        tone: { name: 'Professional', tvalue: 'pf' },
        scenario: '',
        header: 'Generate Email',
        scenarioLable: 'Generate Email',
        generationType: 'GenerateEmail',
    }

    export interface EmailGenerationScenarioResponse {
        subject: string;
        body: string;
    }

    export const EmailGenerationTypes = {
        GenerateEmail: 'GenerateEmail',
        GenerateReply: 'GenerateReply',
        GenerateFollowup: 'GenerateFollowup',
    };

    export type EmailGenerationType = keyof typeof EmailGenerationTypes;

    export const EmailGenerationHeader = {
        GenerateEmail: 'Generate Email',
        GenerateReply: 'Generate Reply',
        GenerateFollowup: 'Generate Followup',
    };

    export const EmailGenerationScenarioLabel = {
        GenerateEmail: 'Describe your scenario',
        GenerateReply: 'Describe your scenario',
        GenerateFollowup: 'Describe your scenario',
    };
}
